// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let IsNewQueryParam = require("./IsNewQueryParam.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let TeamMarketingProfileLogoForm = require("./TeamMarketingProfileLogoForm.bs.js");
let TeamMarketingProfileTeamPhotoForm = require("./TeamMarketingProfileTeamPhotoForm.bs.js");
let TeamMarketingProfilePhotosSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfilePhotosSettingsQuery_graphql.bs.js");

function TeamMarketingProfilePhotosSettings$Header(props) {
  let match = IsNewQueryParam.use();
  let displayName = MarketingProfileSubpages.Page.Team.useDisplayName();
  let breadcrumbs = [
    {
      name: "Team Marketing Profile",
      href: "/account/team_marketing_profile"
    },
    {
      name: displayName("Photos"),
      href: MarketingProfileSubpages.Page.Team.path("Photos")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h2", {
            children: displayName("Photos"),
            className: "text-zinc-800 text-3xl font-medium"
          }),
          ReactRender.ifTrue(JsxRuntime.jsx("p", {
            children: "Your team's marketing profile is now active. Let's start adding more information to it. You can come back at any time to finish.",
            className: "text-base text-zinc-500"
          }), match[0])
        ],
        className: "space-y-2"
      })
    ],
    className: "space-y-3"
  });
}

let Header = {
  make: TeamMarketingProfilePhotosSettings$Header
};

let convertVariables = TeamMarketingProfilePhotosSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfilePhotosSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfilePhotosSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, TeamMarketingProfilePhotosSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(TeamMarketingProfilePhotosSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfilePhotosSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  let hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  let match$1 = IsNewQueryParam.use();
  let subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  let nextPage = Stdlib_Option.flatMap(Stdlib_Array.findIndexOpt(subpages, param => param.page === "Photos"), i => subpages[i + 1 | 0]);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "TeamMarketingProfile") {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(TeamMarketingProfilePhotosSettings$Header, {}),
              className: "pb-2"
            }),
            JsxRuntime.jsx(TeamMarketingProfileLogoForm.make, {
              teamMarketingProfile: marketingProfile.fragmentRefs
            }),
            ReactRender.ifTrue(JsxRuntime.jsx(TeamMarketingProfileTeamPhotoForm.make, {
              teamMarketingProfile: marketingProfile.fragmentRefs
            }), hasFullProfile)
          ],
          className: "space-y-8 sm:space-y-0 divide-y divide-zinc-200"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
              href: Scalars.URL.toString(marketingProfile.publicUrl),
              target: "_blank",
              children: "View Profile"
            }),
            match$1[0] && nextPage !== undefined ? JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                  href: nextPage.path + `?is_new=1`,
                  children: "Continue"
                }),
                className: "flex items-baseline gap-6"
              }) : null
          ],
          className: "flex justify-between border-t border-zinc-200 pt-4"
        })
      ],
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = TeamMarketingProfilePhotosSettings;

exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
